// extracted by mini-css-extract-plugin
export default {"container":"ProjectsLeftBar_container__8n11u","open":"ProjectsLeftBar_open__d-29O","wrapper":"ProjectsLeftBar_wrapper__jVsr7","leftContainer":"ProjectsLeftBar_leftContainer__LCU-t"};